import { render } from "./ProfileUpdate.vue?vue&type=template&id=5ecbaaae&scoped=true&ts=true&lang=pug"
import script from "./ProfileUpdate.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileUpdate.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileUpdate.vue?vue&type=style&index=0&id=5ecbaaae&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ecbaaae"]])

export default __exports__